"use strict";

exports.__esModule = true;
var _DetailsComponents = require("./DetailsComponents");
Object.keys(_DetailsComponents).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DetailsComponents[key]) return;
  exports[key] = _DetailsComponents[key];
});
var _DetailsSubSection = require("./DetailsSubSection");
Object.keys(_DetailsSubSection).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DetailsSubSection[key]) return;
  exports[key] = _DetailsSubSection[key];
});